
import { mapGetters } from 'vuex'
export const orderMixin = {  
  data() {
      return {   
          columns: [                
              { label: this.i18n("DocumentQueryTable.FactoryType"), name: "factoryName",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.VendorCode"), name: "lifnr",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.Vendor"), name: "cusAbbreviation",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderNo"), name: "bsart_ebeln",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.DocumentVersion"), name: "zzebver",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderDate"), name: "aedat",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderViewed"), name: "isViewTxt",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderConfirm"), name: "confirmTimeTxt",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.Purchaser"), name: "ekgrpTxt",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.Function"), name: "func"}
          ],
          config: {
              card_mode: false,
              show_refresh_button: false,
              show_reset_button: false,
              per_page: 10,
              server_mode: true, // by default false
              per_page_options: [10, 25, 50],
              global_search: {
                  visibility: false
              },
              preservePageOnDataChange: false
          },
          classes: {},          
          orderSearchObj : {
                rows:[] , 
                totalCount :0 ,
                filter : {}
          },
          orderDetailRow: {},
          InitFinished : false,
          deliverySearchResult : [],
          memberList : [] //所有符合採購的廠商
      }
  },
  methods: {
    //...mapActions(['updateLoading']),    
    i18n (keyStr){
      return this.$t(keyStr);
    },
    doOrderSearch (orderQueryParam , isEvent){ 
        const self =this;
        const param = orderQueryParam;        
        let url;
        if(this.searchType === 'Order'){
          url = `${this.$apiUrl_Order}/SearchOrderPageAsync`
        }else if(this.searchType === 'ChangeOrder'){
          url = `${this.$apiUrl_Order}/SearchChangeOrderPageAsync`
        }        
        if(isEvent){
            // this.orderSearchObj.totalCount= 0;
            // this.orderSearchObj.rows=[];
        }
        this.updateLoading(true);
        this.axios.post(url, param).then((response) => {
            const {status , statusMessage} = response.data;
            this.updateLoading(false);
            if(status){
                this.$alert(statusMessage,'警告',{type: 'warning'});
            }else{
                //--成功          
                const respObj = response.data;
                respObj.filter = param;
                const rows = respObj.rows;
                rows.forEach(r => {
                    //aedat 訂單日期
                    let aedat = r.aedat;
                    r.aedat = self.fixDate(aedat);
                    let isView = self.fixIsView(r.isView);//看過否
                    r.isViewTxt = isView;
                    let confirmTime = self.fixConfirmTime(r.confirmTime);//廠商確認
                    r.confirmTimeTxt = confirmTime;
                    r.bsart_ebeln = r.bsart + '-' + r.ebeln;
                });
                this.orderSearchObj = respObj;   
                this.setCacheQueryParam(this.searchType + '_QueryParam' , respObj.filter);
            }                    
        })             
    },
    doDeliverySearch (queryParam){ // 出貨單查詢
        const url = `${this.$apiUrl_Order}/SearchDeliveryAsync`
        const param= queryParam;
        const self =this;
        this.axios.post(url, param).then((response) => {
            const {status , statusMessage} = response.data;
            this.updateLoading(false);
            if(status){
                this.$alert(statusMessage,'警告',{type: 'warning'});
            }else{                
                //--成功          
                const rows = response.data;                       
                rows.forEach(r => {                    
                    r.aedatTxt = self.fixDate(r.aedat);
                    r.eindtTxt = self.fixDate(r.eindt);
                    r.shipments = (r.menge - r.grqty).toFixed(3);
                    r.maxShipments = r.shipments;
                });
                self.deliverySearchResult = rows;   
                self.setCacheQueryParam('Delivery_QueryParam' , param);
            }                    
        }) 
    },
    fixDate(v){
        if(v && v.length >10){
            let newV= v.substring(0,10);
            return newV.replaceAll('-', '/');            
        }
        return v;
    },
    fixNumber(v){
        if(v){
            let vNum = v + '';
            let newV= parseInt(vNum,10);
            return newV+'';            
        }
        return v;
    },    
    fixIsView(v){
        if(v === true){
            return 'Y'
        }else{
            return 'N'
        }
    },
    fixConfirmTime(v){
        if(v){
            return '已確認'
        }else{
            return '未確認'
        }
    },
    paginationInfoTwText(props){            
        const {filter ,totalCount} = this.orderSearchObj;
        let startRecNo = 0;
        let endRecNo = 0;
        if(totalCount && totalCount > 0 && filter && filter.pageSize && filter.pageIndex){
            startRecNo = 1 + (filter.pageIndex - 1 ) * filter.pageSize;
            endRecNo = startRecNo + filter.pageSize -1;
            if(endRecNo > totalCount){
                endRecNo = totalCount ;
            }
            return `第 ${startRecNo}筆 ~ 第 ${endRecNo}筆資料列(共${props.originalRowsLength}筆)`;
        }else{
            return '無任何資料列';
        }            
    },        
    onChangeQuery(queryParams) {                
        if(!this.InitFinished){
            this.InitFinished=true;
            return; //初始化未完成
        } 
        let search =  {};
        ({factoryId : search.factoryId, vendorId : search.vendorId,orderDateBegin : search.orderDateBegin,orderDateEnd : search.orderDateEnd,orderNoBegin : search.orderNoBegin,orderNoEnd : search.orderNoEnd,isViewed : search.isViewed,isConfirm : search.isConfirm ,vendorIdList : search.vendorIdList } = this.orderSearchObj.filter);            
        search.pageSize=queryParams.per_page;
        search.pageIndex=queryParams.page;                 
        this.doOrderSearch(search);            
    },
    getOrderDetail(orderId){
        let url;
        if(this.searchType === 'Order'){
          url = `${this.$apiUrl_Order}/GetOrderDetail/${orderId}`
        }else if(this.searchType === 'ChangeOrder'){
          url = `${this.$apiUrl_Order}/GetChangeOrderDetail/${orderId}`
        }          
        this.updateLoading(true);
        this.axios.get(url, {}).then((response) => {
            //const {status , statusMessage} = response.data;
            this.updateLoading(false);
            this.orderDetailRow = response.data;

        });
    },
    reBuildRemarkList (srcRow){
        const rt = [];
        let {remark1,remark2,remark3,remark4,remark5} = srcRow;            
        if(remark1) rt.push(remark1);
        if(remark2) rt.push(remark2);
        if(remark3) rt.push(remark3);
        if(remark4) rt.push(remark4);
        if(remark5) rt.push(remark5);      
        if(rt.length ==0)      {
            rt.push('');  
        }
        return rt;
    },
    getRemarkItemTxt (it,index){
        if(index === 0){
            return this.i18n('DocumentQueryInfo.Memo') + ': ' + it;
        }else{
            return it;                
        }
    },
    initMemberList(){
        this.$store.dispatch('getMemberList',{}).then((data) => {
            this.memberList = data;
        });  
    },
    memberListFilter (filterFactoryId){
        const list = [];            
        if(this.memberList){
            //const filterFactoryId= this.orderQueryParam.factoryId;
            this.memberList.forEach(e => {
                let add=true;
                if(filterFactoryId){
                    if(e.vendorId.startsWith(filterFactoryId)){
                        add=true;
                    }else{
                        add=false;
                    }
                }
                if(add){
                    //list.push({id: e.vendorId , text: e.vendorName});
                    const labelTxt = e.vendorId + ' - ' + e.vendorAbbreviation;
                    list.push({id: e.vendorId , text: labelTxt});
                }
            });
        }
        return list;
    }
  },
  computed : {     
      ...mapGetters(['lang']), 
      isAdmin (){           
          return this.$isAdmin;
      }
  },
  mounted() {
    //this.InitFinished =true;
  },
  watch: {
      lang: function() {
        this.columns = [                
            { label: this.i18n("DocumentQueryTable.FactoryType"), name: "factoryName",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.VendorCode"), name: "lifnr",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.Vendor"), name: "cusAbbreviation",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderNo"), name: "bsart_ebeln",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.DocumentVersion"), name: "zzebver",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderDate"), name: "aedat",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderViewed"), name: "isViewTxt",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderConfirm"), name: "confirmTimeTxt",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.Purchaser"), name: "ekgrpTxt",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.Function"), name: "func"}
        ]
      }
  }
}